import React, { useState, useEffect } from "react";

const PropositoComponent: React.FC = () => {
  const slides = [
    { description: "Nuestro propósito", title: "Conectar a las personas con tiempo de calidad" },
    { description: "Visión", title: "Progreso para la humanidad" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState("enter"); // 'enter' o 'exit'

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection("exit");
      setTimeout(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
        setDirection("enter");
      }, 1000); // Se superpone ligeramente al tiempo de entrada
    }, 5000);

    return () => clearInterval(interval); // Limpieza del intervalo
  }, [slides.length]);

  return (
    <div className="nuestro-proposito">
      <div className={`description ${direction}`}>
        {slides[currentSlide].description}
      </div>
      <div className={`title ${direction}`}>
        {slides[currentSlide].title}
      </div>
    </div>
  );
};

export default PropositoComponent;
